import React, { Children } from 'react'; 
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip'; 
import { CustomIconProps } from './customIconProps';

const CustomIcon: React.FC<CustomIconProps> = ({
    children,
    onClick,
    tooltipText,
    style,
    disabled
}) => (  
    <Tooltip title={tooltipText} arrow> 
        <IconButton onClick={onClick} sx={{ ...style }} disabled={disabled} >
            {children}
        </IconButton>
    </Tooltip>
);
 
export default CustomIcon;
    
